/**
 * @module ol/format/FormatType
 */

/**
 * @enum {string}
 */
export default {
  ARRAY_BUFFER: 'arraybuffer',
  JSON: 'json',
  TEXT: 'text',
  XML: 'xml'
};

//# sourceMappingURL=FormatType.js.map


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/ol/format/FormatType.js
// module id = ../../../../ol/format/FormatType.js
// module chunks = 3